var industryInfo={
    classList:[
        {
            'name':"机器视觉系统",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/shipin/%E6%A6%A8%E8%8F%9C%E8%A3%85%E7%AE%B1.mp4",
                    'title':"视觉引导随动抓定点放",
                    'lable':"通过视觉系统深度学习技术，识别散乱来料并由机械手抓取最表层物料放至固定位置，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/xj.png",
                            'title':"利用深度学习"
                        },
                        {
                            'icon':"/static/case/dl.png",
                            'title':"解决叠料问题"
                        }
                    ]
                }
            ]
        },
        

        {
            'name':"并联机器人",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/shipin/%E6%9D%AF%E8%A3%85%E5%A5%B6%E5%85%A5%E6%89%98.mp4",
                    'title':"杯装奶入托",
                    'lable':"零散杯装奶经螺旋理料后由输送带传送至分托机进行理料分托，由传感器识别、检测，并由机械手定点跟踪抓取装托——自动插管——成托理料，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度24000杯/小时/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5毫米"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工7人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期18个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll-1.png",
                            'title':"灌装机出杯奶"
                        },
                        {
                            'icon':"/static/case/cgqjc.png",
                            'title':"传感器检测"
                        },{
                            'icon':"/static/case/ll.png",
                            'title':"分道机构分道"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"杯奶、托盘定位"
                        }
                        ,
                        {
                            'icon':"/static/case/fz.png",
                            'title':"机器人抓取装托"
                        }
                    ]
                },

                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/shipin/%E6%9D%AF%E8%A3%85%E5%A5%B6%E8%A3%85%E6%A1%86%E5%B7%A5%E4%BD%9C%E7%AB%99.mp4",
                    'title':"杯装奶装筐工作站",
                    'lable':"杯装奶经灌装机出料后由输送带传送至机器人下方，由传感器识别、检测，并由机械手定点跟踪抓取、放至转运筐中，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度8600杯/小时/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5毫米"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期24个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"灌装机出杯奶"
                        },
                        {
                            'icon':"/static/case/cgqjc.png",
                            'title':"传感器检测"
                        },{
                            'icon':"/static/case/ll-1.png",
                            'title':"分道机构分道"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"杯奶定位"
                        }
                        ,
                        {
                            'icon':"/static/case/fz.png",
                            'title':"机器人抓取装筐"
                        }
                    ]
                },

                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/shipin/%E5%86%B0%E6%B7%87%E6%B7%8B%E8%A3%85%E7%AE%B1.mp4",
                    'title':"冰淇淋装箱",
                    'lable':"包装完成的冰淇淋由输送带传送至机器人下方，通过传感器识别、定位，机器手定点跟踪抓取并放至纸箱，箱满后进入下一循环。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度130只/分钟/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±1毫米"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工3人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升50%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期24个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"包装机出料"
                        },
                        {
                            'icon':"/static/case/ll-1.png",
                            'title':"依次落入步进理料槽"
                        },{
                            'icon':"/static/case/cgqjc.png",
                            'title':"传感器检测定位"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"机器人抓取一层装箱"
                        }
                    ]
                },

                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/shipin/%E8%A2%8B%E8%A3%85%E7%B2%89%E5%89%82%E8%A3%85%E7%AE%B1%20.mp4",
                    'title':"袋装粉剂装箱",
                    'lable':"袋装粉剂经灌装机出料后由输送带传送至工业相机下方，通过视觉系统定位、识别、检测来料并由机械手定点跟踪抓取、放置纸箱中直至满箱，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度110袋/分钟/2台"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        },
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升120%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期11个月"
                        }
                        
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"包装机出料"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"视觉检测"
                        },{
                            'icon':"/static/case/fj.png",
                            'title':"机器人抓取"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"放入纸箱"
                        }
                    ]
                },

                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/shipin/%E7%81%AB%E8%85%BF%E8%82%A0%E5%85%A5%E6%8B%89%E4%BC%B8%E8%86%9C%E5%8C%85%E8%A3%85%E6%9C%BA%20%20.mp4",
                    'title':"火腿肠入拉伸膜包装机",
                    'lable':"散料火腿肠经前端离心理料后经由高速单道输送线输送至布进皮带，由机器人定点跟踪抓取并放置料仓中，热输送包装自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度500根/分钟/台"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工4人"
                        },
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期10个月"
                        }
                        
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"火腿肠理料入隔板线"
                        },
                        {
                            'icon':"/static/case/cgqjc.png",
                            'title':"传感器检测物料位置"
                        },{
                            'icon':"/static/case/fj.png",
                            'title':"机器人随动抓取"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"放入包装机料槽"
                        }
                    ]
                },

                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/shipin/%E5%88%A9%E4%B9%90%E6%9E%95%E8%A3%85%E7%AE%B1.mp4",
                    'title':"利乐枕装箱",
                    'lable':"利乐枕经包装机出料后由输送带传送至机器人下方，通过传感器定位、识别，机器手定点跟踪抓取并放至纸箱，箱满后进入下一循环。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度240袋/分钟/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5毫米"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工3人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升120%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期20个月"
                        }
                        
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"灌装机出利乐枕"
                        },
                        {
                            'icon':"/static/case/cgqjc.png",
                            'title':"传感器检测定位"
                        },{
                            'icon':"/static/case/fj.png",
                            'title':"机器人随动抓取"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"随动装箱计数"
                        }
                    ]
                },

                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/shipin/%E4%BC%91%E9%97%B2%E9%A3%9F%E5%93%81%E8%A3%85%E6%89%98%E8%87%AA%E5%8A%A8%E5%8C%96%E6%96%B9%E6%A1%88.mp4",
                    'title':"休闲食品装托自动化方案",
                    'lable':"小面包经由包装机包装后，滑落到传送带上，经由视觉系统定位后，将位置输送给机器人，机器人控制器对物料进行智能分配，将数据分发给4台机器人，由四机联动完成物料高速抓取和装托，实现100%满托输入枕包机，进行二次包装，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度80袋/分钟/台"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        },
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期12个月"
                        }
                       
                        
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"包装机出料"
                        },
                        {
                            'icon':"/static/case/cgqjc.png",
                            'title':"视觉检测定位"
                        },{
                            'icon':"/static/case/fj.png",
                            'title':"机器人抓取"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"放入装托"
                        }
                        ,
                        {
                            'icon':"/static/case/bz.png",
                            'title':"二次包装"
                        }
                    ]
                },

                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/shipin/%E6%A6%A8%E8%8F%9C%E8%A3%85%E7%AE%B1.mp4",
                    'title':"榨菜装箱",
                    'lable':"80克/袋真空袋装榨菜经过水杀菌、烘干后由传送带输送至工业相机下方，通过视觉系统深度学习技术，识别散乱来料并由机械手抓取最表层物料放至固定位置，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度80袋/分钟/台"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工8人"
                        },
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期12个月"
                        }
                       
                        
                    ],
                    'process':[
                        {
                            'icon':"/static/case/mj.png",
                            'title':"物料二次灭菌"
                        },
                        {
                            'icon':"/static/case/ll.png",
                            'title':"提升机理料上料"
                        },{
                            'icon':"/static/case/sjdw.png",
                            'title':"AI视觉识别堆叠物料的位置"
                        },
                        {
                            'icon':"/static/case/fj.png",
                            'title':"机器人抓取"
                        }
                        ,
                        {
                            'icon':"/static/case/fz.png",
                            'title':"装箱"
                        }
                    ]
                },
            ]
        },
       
    ],
    name:"食品",
    title:"solutions",
    subtitle:"食品行业应用案例",
    subinfo:"我们的应用案例包括食品装箱、生产线上下料、包装等服务，助力食品产业升级，提高产能。",
}

export default {
    industryInfo
  };    


// WEBPACK FOOTER //
// ./src/data/industryInfo/5.js